import { authInstance } from "apis";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import ApiError from "types/ApiError";

const useDownloadExcel = ({ onSuccess }: { onSuccess: () => void }) => {
  const fetcher = async (dto: { ids: number[] }) => {
    const { data } = await authInstance.post("/pin/excel/download", dto);
    return data;
  };

  const { mutate, isLoading } = useMutation(fetcher, {
    onSuccess: (fileUrl) => {
      const a = window.document.createElement("a");
      a.href = fileUrl;
      a.click();
      window.URL.revokeObjectURL(fileUrl);
      onSuccess();
    },
    onError: (error: AxiosError<ApiError>) => {
      alert(error.response?.data.message);
    },
  });

  return { mutate, isLoading };
};

export default useDownloadExcel;
